{
  "defaultEntitySelectLabel": "Nombre",
  "defaultRelationSelectLabel": "Relación"
}
